import qs from 'query-string';
import mapValues from 'lodash/mapValues';
import isNil from 'lodash/isNil';
import findKey from 'lodash/findKey';

import {dayString} from '~/misc/dates';
import * as urls from '~/routing/urls';
import { getUrlQeury } from '~/misc/formatUrlquery';
import stateData from '~/misc/country-info';
import { humanToId } from '~/misc/equipment';

let none;

const toNone = (value) => (isNil(value) || value === '') ? none : value;

const loadsURL = (query) => {
  const routerParams = getUrlQeury() || {}
  const state = query.from_state || routerParams.from_state_name
  const country = query.from_country || routerParams.from_country_name
  const countryList = stateData[country] || []
  const stateList = countryList.filter(x => x.value === state)
  const stateFullName = stateList.length ? stateList[0].label : ''
  const city = query.from_city
  const equipment = query.equipment
  const equipmentFullName = !equipment.length ? 'all-loads' : equipment.length === 1 ? findKey(humanToId, item => item === equipment[0]) : ''
  const routerList = [stateFullName, city, equipmentFullName].filter(x => !!x)
  let router = urls.SEARCHLOADS
  if(window.location.pathname === '/capacity-ratio' || window.location.pathname === '/capacity-ratio/all-loads'){
    router = urls.CAPACITYRATIO
  }



  if (routerList.length) {
    routerList.forEach(item => {
      router += `/${item}`
    })
  }
  return `${router}?${qs.stringify(mapValues({
    ...query,
    date: query.date && query.date.map(dayString),
  }, toNone))}`
}

export default loadsURL;



// WEBPACK FOOTER //
// ./src/modules/loadsSearch/url.js